import { render } from "./talents-list.vue?vue&type=template&id=ef463c8a&ts=true"
import script from "./talents-list.vue?vue&type=script&lang=ts"
export * from "./talents-list.vue?vue&type=script&lang=ts"

import "./talents-list.vue?vue&type=style&index=0&id=ef463c8a&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__